import { subscriptionDetails as EnUsSubscriptionDetails } from '../en-us/subscriptionDetails';
import { AgResourceLanguage } from '../types';

export const subscriptionDetails: AgResourceLanguage['subscriptionDetails'] = {
  ...EnUsSubscriptionDetails,
  orderFields: {
    ...EnUsSubscriptionDetails.orderFields,
    nextTextBtn: 'Produkt zur nächsten Bestellung hinzufügen',
    subscriptionTitle: 'Abonnierte Produkte',
    nextTitle: 'Einmalige Add-Ons',
    subscriptionTextBtn: 'Produkt zum Abonnement hinzufügen',
    subscriptionSubtotal: 'Abonnement-Zwischensumme',
    nextSubtotal: 'Zwischensumme einmaliger Add-ons'
  },
  active: {
    ...EnUsSubscriptionDetails.active,
    exploreButton: 'Produkt hinzufügen',
    free: 'Kostenlos',
    shippingAddress: 'Lieferadresse',
    emptyButton: 'Produkt zur nächsten Bestellung hinzufügen',
    nextOrderLabel: 'Nächstes Bestelldatum:',
    subscriptionProductsTitle: 'Abonnierte Produkte',
    lastOrderDetails: 'Details zur letzten Bestellung',
    nextOrderButton: 'Produkt zur nächsten Bestellung hinzufügen',
    qty: 'x',
    addOns: 'Einmalige Add-Ons:',
    emptyText: 'Entdecke alle Produkte von AG1 – exklusiv für Member',
    emtyTitle: 'Einmalige Add-Ons:',
    subscriptionButton: 'Produkte hinzufügen',
    nextShipmentTitle: 'Nächster Versand',
    backButton: 'Zurück zur Liste',
    orderTotal: 'Summe:'
  },
  reactivate: {
    ...EnUsSubscriptionDetails.reactivate,
    headline:
      'Dein Abonnement wurde gekündigt und eine Bestätigungs- E - Mail wird an {{email}} gesendet.',
    title: 'Falls du uns vermisst...',
    subTitle:
      'Wir würden uns freuen, dich wieder bei uns zu haben! Wusstest du, dass diese Optionen es dir leicht machen, eine Lieferung zu überspringen oder mehr Wert aus deinem AG1- Abonnement zu ziehen?',
    agzSubTitle:
      'Wir freuen uns, Sie wieder bei uns begrüßen zu dürfen! Sie können sich jederzeit anmelden und Ihr Abonnement durch Klicken auf „Reaktivieren“ neu starten.',
    reactivateOfferCard: {
      delay: {
        heading: '„Ich habe zu viel.“',
        text: 'Brauchst du ein wenig Zeit, um aufzuholen? Verzögere deine nächste Lieferung von AG1.',
        btnText: 'Reaktivieren & Verzögern'
      },
      skip: {
        heading: '„Ich habe zu viel.“',
        text: 'Brauchst du ein wenig Zeit, um aufzuholen? Überspringe deine nächste Lieferung von AG1.',
        btnText: 'Reaktivieren & Überspringen'
      },
      switch: {
        heading: '„Ich habe ein begrenztes Budget.“',
        textTwoPouches:
          'Wechsle zu 2 Beuteln, die alle 60 Tage versendet werden, um von exklusiven Mitgliederpreisen bei weniger Lieferungen zu profitieren (ein Wert von 18 {{symbolCurrency}}).',
        textThreePouches:
          'Wechsle zu 3 Beuteln, die alle 90 Tage versendet werden, um von exklusiven Mitgliederpreisen und kostenlosem Versand zu profitieren – ein Wert von 42 {{symbolCurrency}}.',
        btnText: 'Reaktivieren & Wechseln'
      },
      upgrade: {
        heading: '“Ich mag den Geschmack nicht.”',
        text: 'Wechseln Sie mit einem Klick Ihr Abonnement zu unserer verbesserten Formel mit mehr Probiotika, Nährstoffen und neuem tropischen Geschmack.',
        learnMoreLinkText: 'Erfahren Sie mehr.',
        btnText: 'Reaktivieren und aktualisieren'
      }
    }
  },
  reactivateConfirm: {
    ...EnUsSubscriptionDetails.reactivateConfirm,
    title: 'Bestätige deinen neuen Plan',
    tableHead: 'Du wirst abgerechnet am:',
    tableSubHead: 'Du hast einen',
    tableSubHeadValue: 'Wert',
    tableSubHeadOn: 'freigeschaltet auf',
    subTotal: 'Zwischensumme',
    shipping: 'Versand',
    free: 'KOSTENLOS',
    total: 'Gesamt',
    confirmButton: 'Bestätigen',
    cancelButton: 'Nein, danke',
    offer: {
      subtitleThreePouches:
        'Reaktiviere dein Abonnement und profitiere von exklusiven Mitgliederpreisen und kostenlosem Versand – ein Wert von {{symbolCurrency}}42.',
      subtitleTwoPouches:
        'Reaktiviere dein Abonnement und profitiere von exklusiven Mitgliederpreisen mit weniger Lieferungen – ein Wert von {{symbolCurrency}}18.',
      promotionText: '{{pouches}} Beutel und weniger Lieferungen'
    },
    newPlan: {
      title: 'Dein neuer AG1-Plan:',
      titleSecondary: 'Dein AG1 wird versendet:',
      mainText: '{{pouches}} Beutel, die alle {{days}} Tage versendet werden',
      nextShipment: 'Nächste Lieferung:'
    }
  },
  reactivateSuccess: {
    ...EnUsSubscriptionDetails.reactivateSuccess,
    title: 'Wir freuen uns, dich wieder bei uns zu haben!',
    subBtn: 'Mein Abonnement ansehen',
    learnMore: {
      title: 'Grundlegende Ernährung in einem einzigen Löffel',
      text: 'Jeder Löffel AG1 enthält die gesundheitlichen Vorteile für den ganzen Körper, die du in einer einfachen täglichen Gewohnheit brauchst.*',
      btnText: 'Mehr erfahren'
    },
    offer: {
      skip: 'Wir haben deine Mitgliedschaft reaktiviert und deine nächste Lieferung übersprungen. Gemeinsam kümmern wir uns um unsere Gesundheit.',
      delay:
        'Wir haben deine Mitgliedschaft reaktiviert und deine nächste Lieferung verschoben. Gemeinsam kümmern wir uns um unsere Gesundheit.',
      default:
        'Wir haben deine Mitgliedschaft reaktiviert. Gemeinsam kümmern wir uns um unsere Gesundheit.'
    }
  },
  v2: {
    ...EnUsSubscriptionDetails.v2,
    active: {
      ...EnUsSubscriptionDetails.v2.active,
      nextOrderTitle: 'Nächste Bestellung',
      shippingFrequency: 'Lieferhäufigkeit',
      item: 'Alle'
    },
    editFrequency: {
      day: 'Tag'
    },
    orderItems: {
      subscriptionDescription: 'Abonnement',
      nextOrderOnlyDescription: 'Nur für diese Bestellung',
      toBeAppliedAfterNextOrder: 'Wird nach der nächsten Bestellung angewendet'
    },
    reactivate: {
      success: 'Dein Abonnement wurde reaktiviert'
    },
    errors: {
      apiError: 'Wir haben derzeit ein technisches Problem. Bitte versuchen Sie es später erneut.'
    }
  },
  switched: {
    title: 'Bei Ihrer nächsten Bestellung werden {{productName}} versendet',
    text: 'Mit der folgenden Bestellung am {{nextOrderDate}} wird Ihr Abonnement den Versand von {{productName}} wieder aufnehmen.',
    singularOfPouch: 'Beutel',
    pluralOfPouch: 'Beuteln',
    singularOfTravelPacks: 'Reisepakete',
    pluralOfTravelPacks: 'Reisepaketen',
    omegas: 'und AG1 Omegas'
  }
};
